import Vue from 'vue';
import VxCard from '@/components/vx/card/VxCard.vue';
import VxTable from '@/components/vx/table/index';
import VxTooltip from '@/components/vx/tooltip/VxTooltip.vue';

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.use(VxTable);
